import {
  WidgetQuickActions,
  WidgetChart,
  WidgetStatistics,
} from "@components-common/widgets";
import { HttpResponse } from "@dirootie-core/http-types";
import { Page } from "@components-common/layouts";
import { BarChartStatistics, LineChart } from "@components-common/charts";
import { useEffect, useState } from "react";
import { application } from "../../_runtime/bootstrap";
import { Col, Row } from "taltech-styleguide";
import { WidgetConfig } from '../../components-fabric/_types/components';
import { IconTalTech } from "../../components-common/icons";

const actionsWidget: WidgetConfig & {id:string} = {
  id: "admin_shortcuts",
  Component: WidgetQuickActions,
  title: "Management shortcuts",
  subTitle: "Shortcuts for common operations",
  items: [
    "create_course",
    "create_building_config",
    "create_space_function",
    "create_floor_type",
    "create_wall_type",
    "create_window_type",
    "create_roof_type"
  ],
};

const widgetProps = {
  title: "Assignments statistics",
  subTitle: "",
  className: "",
};

const createWidgetStatisticsProps = (
  title: string,
  number: number,
  icon: JSX.Element
) => ({
  widgetProps: {
    ...widgetProps,
    title,
  },
  number,
  icon,
});

const widgetChartProps = {
  widgetProps: {
    id: "assignments_statistics",
    title: "Lecturers with most count of users",
    subTitle: "",
    className: "",
  },
  chartProps: {
    ChartComponent: BarChartStatistics,
    chartOptions: {
      id: "chart_assignment_submissions_by_students",
      subTitle: "",
      seriesName: "Students",
      height: "300px",
      urlEndpoint:
        "/analyticsms/course-analytics/get-lecturers-with-most-students",
      yAxisProperty: "studentCount",
      xAxisProperty: "lecturerName",
    },
  },
};

const widgetLineChart = {
  widgetProps: {
    id: "assignments_statistics",
    title: "Created users timeline",
    subTitle: "",
    className: "",
  },
  chartProps: {
    ChartComponent: LineChart,
    chartOptions: {
      id: "chart_assignment_submissions_by_students",
      subTitle: "",
      seriesName: "Users",
      height: "200px",
      urlEndpoint: "/analyticsms/user-analytics/get-created-users",
      yAxisProperty: "count",
    },
  },
};

export const DashboardScreen = () => {
  const [data, setData] = useState({
    usersCount: 0,
    coursesCount: 0,
    assignmentsCount: 0,
  });

  useEffect(() => {
    application
      .getHttpClient()
      .get("analyticsms/course-analytics/get-generic-data")
      .then((res: HttpResponse) => {
        setTimeout(() => setData(res.body), 100);
      });
  }, []);

  return (
    <Page title="Dashboard">
      <Row className="m-0">
        <Col sm="12" md="4">
          <Row className="h-100 m-0">
            <WidgetQuickActions {...actionsWidget} />
          </Row>
        </Col>
        <Col sm="12" md="8">
          <Row className="h-100 m-0">
            <WidgetChart {...widgetLineChart}></WidgetChart>
          </Row>
        </Col>
      </Row>
      <Row className="m-0 mt-3">
        <Col sm="12" md="8" lg="9">
          <WidgetChart {...widgetChartProps}></WidgetChart>
        </Col>
        <Col sm="12" md="4" lg="3" className="w-sm-100">
          <Row className="flex-md-column justify-content-between h-100 m-0">
            <WidgetStatistics
              {...createWidgetStatisticsProps(
                "Total Users",
                data.usersCount,
                <IconTalTech kind="students" />
              )}
            />
            <WidgetStatistics
              {...createWidgetStatisticsProps(
                "Total Courses",
                data.coursesCount,
                <IconTalTech kind="course" />
              )}
            />
            <WidgetStatistics
              {...createWidgetStatisticsProps(
                "Total Assignments",
                data.assignmentsCount,
                <IconTalTech kind="assignment" />
              )}
            />
          </Row>
        </Col>
      </Row>
    </Page>
  );
};

// export const dashboardRoute = {
//   ...managementRoutes.route_management_dashboard,
//   screen: {
//     view: {
//       component: DashboardScreen,
//     },
//     layout: layoutWorkspace,
//   },
// };
